/**
 * 会员信息
 */
import React from 'react';

import { Input, Row, Col, Icon, Tooltip, Button, TreeSelect } from 'antd';

import PageLayout from '../../ui/PageLayout';
import TenantEdit from './TenantEdit';

import orgUtil from '../../ui/orgUtil';

import http from '../../../axios/http';
import messager from '../../ui/messager';//充值
import MemberDetail from '../member/MemberDetail';
//代办公司下属用户维护
import MemberTeam from '../member/MemberTeam';
import { global_data } from '../../ui/auth'


class TenantIndex extends React.Component {

    columns = [{
        title: '所属市场',
        dataIndex: 'orgName',
        width: '10%',
    },{
        title: '签约名称',
        dataIndex: 'contractName',
        width: '10%',
    },{
        title: '商户名称',
        dataIndex: 'memberName',
        width: '10%',
    },{
        title: '联系人',
        dataIndex: 'contactMan',
        width: '10%',
    },{
        title: '联系人电话',
        dataIndex: 'contactNumber',
        width: '10%',
    }, {
        title: '地址',
        dataIndex: 'address',
        width: '10%',
    }, {
        title: '租金',
        dataIndex: 'rentFees', 
        width: '10%',
    }, {
        title: '物业费',
        dataIndex: 'propertyFee',
        width: '10%',
    }, {
        title: '押金',
        dataIndex: 'deposit',
        width: '10%',
    }, {
        title: '操作',
        dataIndex: 'memberCode',
        width: '20%',
        render: (text, record, index) => (
            <div>
                {global_data.authCode.includes("TENANT_UPDATE")?
                <Tooltip title="修改">
                    <Icon type="edit" theme="filled" className="table-operate-icon" onClick={this.update.bind(this, record)} />
                </Tooltip>
                :""}
                {global_data.authCode.includes("TENANT_DELETE")?
                <Tooltip title="删除">
                    <Icon type="delete" theme="filled" className="table-operate-icon" onClick={this.delete.bind(this, text)} />
                </Tooltip>
                :""}
                {global_data.authCode.includes("TENANT_MEMBER")?
                <Tooltip title="人员配置">
                    <Icon type="team" className="table-operate-icon" onClick={this.updateTeam.bind(this, record)} />
                </Tooltip>
                :""}
                <Tooltip title="明细">
                    <Icon type="eye" theme="filled" className="table-operate-icon" onClick={this.detail.bind(this, record)} />
                </Tooltip>
            </div>
        )
    }];

    state = {
        visible: false,
        editData: {},
        loadData: '',
        queryData: {},
        orgList: [],
        detailVisible: false, //明细
        summary: {}
    };

    componentDidMount() {
        orgUtil.findOrg(
            { orgType: 4 },   //只查询市场的组织信息
            (res) => {
                this.setState({ orgList: res });
            }
        );
    }

    showModal = () => {
        this.setState({ visible: true });
    };
    hiddenModal = () => {
        this.setState({ visible: false, editData: {} });
    };

    add = () => {
        this.setState({ editData: {} });
        this.showModal();
    }

    update = (info, e) => {
        this.setState({ editData: info });
        this.showModal();
    }

    delete = (info, e) => {
        messager.confirm("是否删除该租户信息？", () => {
            http.post({
                url: "/tenant/deleteTenant",
                data: { memberCode: info },
                success: (res) => {
                    this.state.loadData(this.state.queryData);
                    messager.notify("删除成功！");
                }
            });
        });
    }

    ///代办人员维护
    updateTeam = (info, e) => {
        info.code = info.memberCode;
        info.name = info.memberName;
        this.refs["memberTeam"].initData(info.code,
            (res) => { this.setState({ editData: info, teamVisible: true }) }
        );
    }

    //详情
    detail = (info, e) => {
        info.code = info.memberCode;
        info.name = info.memberName;
        //查询当前账户的汇总信息
        http.post({
            url: '/tenant/findAccountRecordSummary',
            data: { memberCode: info.code },
            success: (res) => {
                this.setState({ summary: res, editData: info, detailVisible: true });
                this.refs["detail"].loadTableData(info.code, "account");
                this.refs["detail"].loadTableData(info.code, "bond");
                this.refs["detail"].loadTableData(info.code, "duration");
            }
        });
    }

    inputSearch = (value) => {
        let queryData = this.state.queryData;
        queryData.memberName = value;
        queryData.contractName = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData)
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={20}>
                                <Input.Search
                                    placeholder="会员名称或签约名称"
                                    onSearch={this.inputSearch}
                                    enterButton
                                    style={{ width: 400, marginRight: '10px' }}
                                />
                                <TreeSelect onChange={this.orgSelect} treeData={this.state.orgList} allowClear={true}
                                    treeDefaultExpandAll={true} style={{ width: '250px' }} />
                            </Col>
                            <Col span={4} style={{ textAlign: "right" }}>
                                {global_data.authCode.includes("TENANT_ADD")?
                                <Button type="primary" onClick={this.add}>新增</Button>
                                :""}
                            </Col>
                        </Row>
                    )}
                    rowKey="memberCode" url="/tenant/findTenantPage" columns={this.columns}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                />
                <TenantEdit
                    visible={this.state.visible}
                    onCancel={this.hiddenModal.bind(this)}
                    editData={this.state.editData}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                />
                <MemberDetail
                    visible={this.state.detailVisible}
                    onCancel={() => { this.setState({ detailVisible: false, editData: {} }) }}
                    editData={this.state.editData}
                    summary={this.state.summary}
                    ref="detail"
                    content="tenant"
                />
                <MemberTeam
                    visible={this.state.teamVisible}
                    onCancel={() => { this.setState({ teamVisible: false, editData: {} }) }}
                    editData={this.state.editData}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                    ref="memberTeam"
                    content="tenant"
                />
            </div>
        )
    }
}

export default TenantIndex;